exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ni-select .ant-select-selector {\n  width: 200px;\n  border: 1px solid #D7D7DE !important;\n  border-radius: 6px;\n}\n.ni-select.ant-select-multiple .ant-select-selector {\n  width: 100%;\n}\n.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  background-color: #f7f7fb !important;\n}\n.ant-select-dropdown .ant-select-item.ant-select-item-option:hover {\n  background-color: rgba(76, 122, 227, 0.12) !important;\n}\n", ""]);

// exports
